import { Component, h, Prop } from '@stencil/core';
import Cookies from 'js-cookie';
import { isBrowser } from '../../constants/constants';

// type for GTM injected liveChat tag functions
declare global {
  interface Window {
    setChatElements: () => void;
  }
}

@Component({
  tag: 'customer-chat',
  styleUrl: 'customer-chat.scss',
  scoped: true,
})
export class CustomerChat {
  /** Id to be used on desktop */
  @Prop() liveEngageId: string;
  /** Id to be used on mobile and tablet */
  @Prop() liveEngageIdMobile: string;

  private bubbleChatIcon = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="ghf-customerChat-icon" >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5431 1C18.766 1 23 5.25329 23 10.5C23 11.9611 22.6716 13.3452 22.085 14.5819L22.9505 18.4469C23.1912 19.5221 22.5164 20.1964 21.4445 19.9533L17.6036 19.0822C16.6562 19.5353 15.622 19.8348 14.5328 19.9486C13.1667 21.7936 10.9731 22.9899 8.5 22.9899C7.23243 22.9899 6.03831 22.6756 4.99139 22.1208L2.44132 22.9099C1.38341 23.2372 0.786825 22.645 1.10946 21.585L1.88635 19.0325C1.32078 17.9788 1 16.7743 1 15.4949C1 12.9761 2.24341 10.7474 4.15031 9.38849C4.6982 4.66552 8.69455 1 13.5431 1ZM17.3698 16.9789L20.756 17.7599L19.9915 14.346L20.2877 13.7215C20.7605 12.7248 21.0091 11.6321 21.0091 10.5C21.0091 6.35786 17.6665 3 13.5431 3C10.1832 3 7.34161 5.22964 6.40463 8.29642C7.06962 8.10345 7.77272 8 8.5 8C12.6421 8 16 11.3556 16 15.4949C16 16.2591 15.8856 16.9965 15.6729 17.691C16.0413 17.5811 17.3698 16.9789 17.3698 16.9789ZM4.0427 18.8278L3.52983 20.4859L5.19015 19.9726L5.93171 20.3652C6.71575 20.7803 7.58986 21 8.5 21C11.5355 21 14 18.5396 14 15.5C14 12.4604 11.5355 10 8.5 10C5.46449 10 3 12.4604 3 15.5C3 16.4219 3.22545 17.3066 3.65061 18.098L4.0427 18.8278ZM8.5 16.5C7.94772 16.5 7.5 16.0523 7.5 15.5C7.5 14.9477 7.94772 14.5 8.5 14.5C9.05229 14.5 9.5 14.9477 9.5 15.5C9.5 16.0523 9.05229 16.5 8.5 16.5ZM11.5 16.5C10.9477 16.5 10.5 16.0523 10.5 15.5C10.5 14.9477 10.9477 14.5 11.5 14.5C12.0523 14.5 12.5 14.9477 12.5 15.5C12.5 16.0523 12.0523 16.5 11.5 16.5ZM5.5 16.5C4.94772 16.5 4.5 16.0523 4.5 15.5C4.5 14.9477 4.94772 14.5 5.5 14.5C6.05228 14.5 6.5 14.9477 6.5 15.5C6.5 16.0523 6.05228 16.5 5.5 16.5Z" fill="var(--color-svg,#fa3c00)"/>
    </svg>
  );

  // Manually trigger LP chat in footer as a fallback
  handleLiveEngageChatClick = () => {
    const element = document.querySelector('.sb-Footer .sb-FooterBodyList-item--chat.sb-Util-hidden--sm.sb-Util-hidden--md .sb-LiveEngage-chat > .LPMcontainer.LPMoverlay > span') as HTMLElement;
    if (element) {
      element.click();
    }
  };

  // update liveperson on component load if it exists
  componentDidLoad() {
    if (isBrowser) {
      // if liveperson is already loaded, it might have missed parsing this element
      window?.setChatElements && window.setChatElements();
    }
  }

  render() {
    const hvprCookie = Cookies.get('ttarp_override');
    const liveEngageId = this.liveEngageId ?? (hvprCookie === '855-792-1402' ? 'LP_DIV_1645056394123' : 'LP_DIV_RB_6687889599')
    const liveEngageIdMobile = this.liveEngageIdMobile ?? 'LP_'

    return (
      <div class="ghf-customerChat--default">
        <div class="img" title="Speech Bubble with Checkmark" >
          {this.bubbleChatIcon}
        </div>
        <div class="ghf-customerChat">
          <span class="ghf-customerChat-text">Chat with a Real Person</span>
          <span id={liveEngageId} class="sb-LiveEngage-chat ghf-customerChat-liveEngage--desktop" onClick={this.handleLiveEngageChatClick}>
            <p class="ghf-customerChat-storeText" aria-hidden="true">
              Chat Now
            </p>
          </span>
          <span id={liveEngageIdMobile} class="sb-LiveEngage-chat ghf-customerChat-liveEngage--mobile">
            Chat Now
          </span>
        </div>
      </div>
    );
  }
}
